export const contactPointSchema = {
  "@type": "ContactPoint",
  "telephone": "+44 117 379 0309",
  "contactType": "customer service",
  "email": "hello@gravitywell.co.uk",
  "areaServed": "GB",
  "availableLanguage": [ "English" ]
};